import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/variables.css';
import './styles/global.css';
import App from './App';
import { preloadRouteChunk } from './routePreload';

const container = document.getElementById('root');
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

function mount() {
  if (container.hasChildNodes()) {
    ReactDOM.hydrateRoot(container, app);
  } else {
    ReactDOM.createRoot(container).render(app);
  }
}

// Le HTML servi peut être pré-rendu (scripts/generate-route-previews.mjs) : dans ce
// cas le conteneur a déjà du contenu et on hydrate au lieu de tout réécrire, pour
// éviter un flash de contenu vide avant que React ne prenne le relais.
//
// Avant d'hydrater, on précharge le chunk JS de la route de la page (React.lazy
// dans App.js) : sans ça, ce chunk n'est pas encore chargé au premier rendu et
// React suspend sur la <Suspense> de la route (fallback=null), qui ne correspond
// pas au HTML déjà présent — erreur d'hydration.
if (container.hasChildNodes()) {
  preloadRouteChunk(window.location.pathname).then(mount, mount);
} else {
  mount();
}
